<template>
  <v-form v-model="valid" class="px-2">
    <v-row>
      <v-col>
        <!-- Inputs to get links informations from users -->
        <v-list-item-title class="mt-1 mb-2 font-weight-medium text-center">{{ $t("LoggedArea.Links.PopUp.Inputs.title")}}</v-list-item-title>        
        <div class="error-text" v-for="(error, index) in errors" :key="index">{{ error }}</div>

        <!-- Enter the name of the link-->
        <v-list-item-title class="mt-2 mb-1 subtitle-2 text-left">{{ $t("LoggedArea.Links.PopUp.Inputs.linkName")}}</v-list-item-title>        
        <v-text-field
          color="purple darken-4"
          v-model="link.linkTitle"
          :rules="linkTitleRules"
          :counter="300"
          :class="link.linkTitle.length > 300 ? 'mb-8 body-2' : 'mb-5 body-2'"
          style="height:40px;"
          outlined
          dense
        >
          <template v-slot:label>
            <span
              style="font-size: 0.875rem ;font-weight: 300;color: #282f37;"
            >{{ $t('LoggedArea.Appearance.CardInputs.linkTitle') }}</span>
          </template>
        </v-text-field>
        <!-- Enter the link URL--> 
        <v-list-item-title class="mt-2 mb-1 subtitle-2 text-left">{{ $t("LoggedArea.Links.PopUp.Inputs.linkURL")}}</v-list-item-title>         
        <v-text-field
          color="purple darken-4"
          v-model="link.linkHttps"
          class="mb-2 body-2"
          style="height:40px;"
          outlined
          dense
        >
          <template v-slot:label>
            <span
              style="font-size: 0.875rem ;font-weight: 300;color: #282f37;"
            >{{ $t('LoggedArea.Appearance.CardInputs.urlLink') }}</span>
          </template>
        </v-text-field>

        <div class="pt-0 mt-5 d-flex justify-center">
          <v-btn
            color="purple darken-4"
            class="font-weight-light text-capitalize"
            dark
            style="outline: none;"
            @click="validationLink"
          >{{ $t('LoggedArea.Appearance.CardInputs.addNew') }}</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { analytics } from "@/config/firebaseConfig";
export default {
  props: ['srcIcon'],
  data() {
    return {
      valid: true,
      empty: 123,
      link: {
        linkTitle: "",
        linkHttps: "",
      },
      linkTitleRules: [
        (v) =>
          v.length <= 300 ||
          this.$t("LoggedArea.Appearance.CardInputs.linkTitleRules"),
      ],
      errors: [],
    };
  },
  methods: {
    validationLink() {
      analytics.logEvent("Btn_SavLink");
      this.errors = [];
      let linkHttpsLower = this.link.linkHttps.toLowerCase();
      if (this.link.linkTitle == "") {
        this.errors.push(
          this.$t("LoggedArea.Appearance.CardInputs.linkRequired")
        );
      }
      if (this.link.linkTitle.length > 300) {
        this.errors.push(
          this.$t("LoggedArea.Appearance.CardInputs.linkLength")
        );
      }
      if (this.link.linkHttps == "") {
        this.errors.push(
          this.$t("LoggedArea.Appearance.CardInputs.urlRequired")
        );
      }
      if (
        !linkHttpsLower.startsWith("http://") &&
        !linkHttpsLower.startsWith("https://")
      ) {
        this.errors.push(this.$t("LoggedArea.Appearance.CardInputs.urlHTTP"));
      }
      if (this.errors.length == 0) {
        this.errors = [];
        this.addLink();
      }
    },
    addLink() {
      this.$emit("add-link", this.link);
      this.$emit("close-pop-up", false);
      this.valid = false;
      this.link.linkTitle = "";
      this.link.linkHttps = "";
    },
  },

};
</script>

<style>
</style>